import { hideAction as hideVehicleConfiguratorAction } from '../../_flux/actions/vehicle_configurator_actions';
import {
    showAction as showInfoPopup,
    setHeaderContentAction as setInfoHeader,
    addBodyContentAction as addInfoBody,
    setBodyButtonTextAction as setInfoButtonText,
    setDispatcherAction as setInfoDispatcher,
} from '../../_flux/actions/info_popup_actions';
import {getTranslatedText} from '../../_flux/helper/get_translated_text';
import {InfoPopupDispatcher} from '../../_constants/info_popup';

export function onShowInfo() {
    hideVehicleConfiguratorAction();
    setInfoDispatcher(InfoPopupDispatcher.VEHICLE_CONFIGURATOR);
    setInfoHeader(getTranslatedText('info-popup-header-vehicle-rego-where-to-find-my-tyre-size'));

    addInfoBody(getTranslatedText('info-popup-body-first-title'));
    addInfoBody(getTranslatedText('info-popup-body-first-content', {
        STATIC_URL: TYROOLA.globals.staticImagesUrl
    }));

    addInfoBody(getTranslatedText('info-popup-body-second-title'));
    addInfoBody(getTranslatedText('info-popup-body-second-content', {
        STATIC_URL: TYROOLA.globals.staticImagesUrl
    }));

    addInfoBody(getTranslatedText('info-popup-body-third-title'));
    addInfoBody(getTranslatedText('info-popup-body-third-content'));

    setInfoButtonText(getTranslatedText('info-popup-body-button-text-vehicle-rego-ok-got-it'));
    showInfoPopup();
}
